import { api } from 'lib/httpClient';
import {
  createFileUploader,
  UploadFileResult as UploadFileResultType,
} from 'further-ui/hooks';

const awsUrl = process.env.REACT_APP_AWS_URL;

const useFileUpload = createFileUploader(
  api.get,
  `${awsUrl}/get-signed-post-url`,
);

export default useFileUpload;

export type UploadFileResult = UploadFileResultType;
